<template>
  <div class="content">
    <div class="row">
      <div class="col-md-10 flex-container-top">
        <h2 class="text-eveer">Events List</h2>
        <base-button
          v-if="role == 'Admin'"
          type="primary"
          round
          icon
          class="top-button"
          @click="$router.push('add?id=-1')"
        >
          <i class="fa fa-plus"></i>
        </base-button>


        <!-- <base-button
          v-if="role == 'Admin'"
          type="primary"
          class="top-button pull-right"
          @click="displayOlderEvents()"
        >
          View Older Events
        </base-button> -->
      </div>
      <div class="col-md-2 flex-container-top">
        <base-button
          v-if="role == 'Admin'"
          type="primary"
          class="top-button pull-right"
          @click="$router.push('list-table')"
        >
          List View
        </base-button>
      </div>
    </div>

    <div class="container-fluid px-0">
      <div class="row mb-3 filter-bar gx-0 px-0">
        <div class="col-12 col-sm-6 col-md-2 col-xl-2 px-0">
          <select
            v-model="pagination.limit"
            class="form-control limit-select"
            @change="fetchEvents(1)"
          >
            <option v-for="n in [6, 12, 24, 48, 100]" :key="n" :value="n">
              Show {{ n }}
            </option>
          </select>
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-xl-2 px-0">
          <input
            v-model="searchQuery"
            type="text"
            class="form-control"
            placeholder="Search events..."
          />
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-xl-2 px-0">
          <input
            v-model="startDate"
            type="date"
            class="form-control date-input"
            @change="setEndDateMin"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-xl-2 px-0">
          <input
            v-model="endDate"
            type="date"
            class="form-control date-input"
            :min="startDate"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-2 col-xl-2 px-0">
          <select
            v-model="sortOrder"
            class="form-control limit-select"
            @change="fetchEvents(1)"
          >
            <option value="desc"> Sort By Date Desc </option>
            <option value="asc">Sort By Date Asc </option>
          </select>
        </div>
        <div class="col-12 col-md-12 col-xl-auto d-grid px-0">
          <div class="d-flex flex-row flex-wrap gap-2">
            <button class="btn btn-primary" @click="fetchEvents(1)">Filter</button>
            <button class="btn btn-outline-secondary" @click="clearFilters">Clear</button>
          </div>
        </div>
        <div class="col-12 px-0">
          <span v-if="dateError" class="text-danger small">{{ dateError }}</span>
        </div>
      </div>

      
    </div>
    
    <div class="row">
      <div class="col-md-4" v-for="eve in events" v-bind:key="eve._id">
        <img class="rest-img" :src="eve.image" alt="..." />
        <card class="card-user">
          <p class="card-text"></p>
          <div class="author">
            <a href="javascript:void(0)">
              <h5 class="title">
                {{ eve.event_name }}
                <a>
                  <i
                    v-if="role == 'Admin'"
                    class="fas fa-edit"
                    title="Edit Event"
                    @click="$router.push('edit?id=' + eve._id)"
                    style="color: white; margin-left: 10%"
                  ></i>
                </a>
                <a>
                  <i
                    v-if="role == 'Admin'"
                    class="far fa-trash-alt"
                    title="Delete This Event"
                    @click="deleteEvent(eve._id)"
                    style="color: red; margin-left: 10%"
                  ></i>
                </a>
              </h5>
            </a>
            <p>
              <a
                href="javascript:void(0)"
                v-if="role == 'Admin' && eve.event_recurrence_id"
                @click="deleteRecursiveEvent(eve._id)"
                title="Delete Recurrence"
                style="color: red"
              >
                <i class="fa fa-trash"></i> Delete Recurrence
              </a>
            </p>
            <p class="description addres">{{ eve.address }}</p>
          </div>
          <p class="organizerPanel" style="color: white">
            Organizer:
            <span
              class="organizerName"
              v-if="
                eve.organizerNames != null &&
                eve.organizerNames != '' &&
                eve.organizerNames != undefined
              "
            >
              {{ eve.organizerNames }}</span
            >
          </p>
          <div class="card-description descr">
            {{ eve.description }}
          </div>
          <div slot="footer" class="rest-footer">
            <div>
              <button
                class="btn btn-fill"
                @click="$router.push('bookings?event_id=' + eve._id)"
              >
                <i class="fa fa-edit"></i> Bookings
              </button>
            </div>
          </div>
        </card>
        <div class="ribbon" v-if="!eve.is_dynamic_price">
          Prices - {{ eve.early_price }} Early / {{ eve.regular_price }} Regular
        </div>
        <div class="ribbon" v-else>
          Prices - {{ eve.original_price }} Price / {{ eve.min_price }} Min /
          {{ eve.max_price }} Max
        </div>
        <div class="ribbon ribbon-is-special">City - {{ eve.city }}</div>
        <div class="ribbon ribbon-is-deal-of-day">
          Schedule {{ eve.date }}{{ eve.end_date ? ` / ${eve.end_date}` : "" }},
          from {{ eve.start_time }} to
          {{ eve.end_time }}
        </div>
        <div class="ribbon ribbon-add-on">
          {{ eve.booked }} Booked /

          <span v-if="!eve.is_unlimited_bookings">{{ eve.total_slots }} </span>

          <span v-if="eve.is_unlimited_bookings">Unlimited </span>

          Total
        </div>
      </div>
      
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>

    <div>
      <!-- <b-button id="show-btn" @click="$bvModal.show('bv-modal-example')">Open Modal</b-button> -->
      <b-modal id="popUpAssignModal" hide-footer>
        <template #modal-title> Using <code>$bvModal</code> Methods </template>
        <div class="d-block text-center">
          <h3>Hello From This Modal!</h3>
        </div>
        <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')"
          >Close Me</b-button
        >
      </b-modal>
    </div>
    <!-- Classic Modal -->
   <b-pagination
        v-if="pagination.totalPages > 1"
        v-model="pagination.currentPage"
        :per-page="pagination.limit"
        :total-rows="pagination.totalRecords"
        :limit="5"
        align="center"
        @input="onPageChange"
        class="my-3"
      />
  </div>
</template>
<script>

import { contourDensity } from "d3";
import { Modal, BaseAlert } from "src/components";
// Import BootstrapVue pagination if not globally imported
// import { BPagination } from 'bootstrap-vue';

export default {
  data() {
    return {
      role: window.localStorage.getItem("role"),
      events: [],
      loading: true,
      noDataMessage: false,
      isOlderEvents: false,
      pagination: {
        totalRecords: 0,
        totalPages: 1,
        currentPage: 1,
        nextPage: null,
        prevPage: null,
        limit: 6,
      },
      searchQuery: "",
      startDate: "",
      endDate: "",
      dateError: "",
      sortOrder: "desc",
    };
  },
  components: {
    Modal,
    BaseAlert,
  },
  async mounted() {
    this.fetchEvents(1);
  },
  methods: {
    async fetchEvents(page) {
      this.loading = true;
      // Validate date range
      if (this.startDate && this.endDate && this.endDate < this.startDate) {
        this.dateError = "End date cannot be less than start date.";
        this.loading = false;
        return;
      } else {
        this.dateError = "";
      }
      // Build API query params
      let params = [`page=${page}`, `limit=${this.pagination.limit}`];
      if (this.searchQuery)
        params.push(`search=${encodeURIComponent(this.searchQuery)}`);
      if (this.startDate) params.push(`startDate=${this.startDate}`);
      if (this.endDate) params.push(`endDate=${this.endDate}`);
      if (this.sortOrder) params.push(`sortOrder=${this.sortOrder}`);
      let queryString = params.join("&");
      let test = await this.$apiService.getCall(
        `event/events-v1?${queryString}`
      );
      if (test.apidata.Code == "EVE002") {
        this.$apiService.notify(
          "Somthing went wrong to get event data. Please, Refresh the page."
        );
      }
      let pagination = test.apidata.Data.pagination;
      this.pagination = pagination;
      this.role = window.localStorage.getItem("role");
      var role = this.role;
      var userid = window.localStorage.getItem("userid");
      // Phase 1 — Task 3D: /event/events-v1 returns Data as { events, pagination }
      // for ALL roles. The previous else branch (for non-Admin) treated Data as
      // an array directly, which caused this.events to be an object and .sort()
      // to throw "this.events.sort is not a function" on Organizer login.
      this.events = (test.apidata.Data && test.apidata.Data.events) || [];
      if (Array.isArray(this.events)) {
        this.events = this.events.map((event) => {
          let names = "";
          if (event.organizers && event.organizers.length > 0)
            event.organizers.map((organizer) => {
              if (organizer.userData) {
                if (names != "") names += ", ";
                names +=
                  (organizer.userData.first_name || "") +
                  " " +
                  (organizer.userData.last_name || "");
              }
            });
          return { ...event, organizerNames: names };
        });
      } else {
        this.events = [];
      }
      this.events.sort(
        (a, b) =>
          this.compare(a.date, b.date) ||
          this.compare(a.start_time, b.start_time)
      );
      this.loading = false;
      if ((this.events || []).length == 0) {
        this.noDataMessage = true;
      } else {
        this.noDataMessage = false;
      }
    },
    async compare(a, b) {
      if (a > b) return +1;
      if (a < b) return -1;
      return 0;
    },
    onPageChange(page) {
      this.fetchEvents(page);
    },
    async deleteRecursiveEvent(id) {
      let confirmed = confirm(
        "Are you sure you want to delete all recursive events assosicated with this event ?"
      );
      if (confirmed === true) {
        this.loading = true;
        const del_event_status = await this.$apiService.getCall(
          "event/recursive-event-delete/" + id
        );
        const message =
          del_event_status &&
          del_event_status.apidata &&
          del_event_status.apidata.Message;
        if (del_event_status.isError || message !== "Success") {
          this.loading = false;
          this.$apiService.notify(message || "Unable to delete recurring events.");
        } else {
          await this.fetchEvents((this.pagination && this.pagination.currentPage) || 1);
          this.$apiService.notify("Recursive Events has been deleted.");
        }
      }
    },
    async deleteEvent(id) {
      let confirmed = confirm("Are you sure you want to delete this Event? ");
      if (confirmed === true) {
        this.loading = true;
        const del_event = await this.$apiService.getCall(
          "event/event-delete/" + id
        );
        const message =
          del_event &&
          del_event.apidata &&
          del_event.apidata.Message;
        if (del_event.isError || message !== "Success") {
          this.loading = false;
          this.$apiService.notify(message || "Unable to delete event.");
        } else {
          await this.fetchEvents((this.pagination && this.pagination.currentPage) || 1);
          this.$apiService.notify("Event has been deleted.");
        }
      }
    },
    async displayOlderEvents() {
      if (!this.isOlderEvents) {
        this.events = [];
        this.loading = true;
        let test = await this.$apiService.getCall(
          "event/events?displayOlderEvents=1"
        );
        if (test.apidata.Code == "EVE002") {
          this.$apiService.notify(
            "Somthing went wrong to get event data. Please, Refresh the page."
          );
        }
        this.events = test.apidata.Data || [];
        let temp = this.events.map((event) => {
          let names = "";
          if (event.organizers && event.organizers.length > 0)
            event.organizers.map((organizer) => {
              if (organizer.userData) {
                if (names != "") names += ", ";
                names +=
                  organizer.userData.first_name +
                  " " +
                  organizer.userData.last_name;
              }
            });
          return { ...event, organizerNames: names };
        });
        this.events = temp;
        this.events.sort(
          (a, b) =>
            this.compare(a.date, b.date) ||
            this.compare(a.start_time, b.start_time)
        );
        console.log(this.events);
        this.isOlderEvents = true;
        this.loading = false;
      } else {
        this.$apiService.notify("Already older events displayed.");
      }
    },
    setEndDateMin() {
      // This will automatically update the min attribute of endDate input
      // because :min is bound to startDate
      if (this.endDate && this.endDate < this.startDate) {
        this.endDate = "";
      }
    },
    clearFilters() {
      this.searchQuery = "";
      this.startDate = "";
      this.endDate = "";
      this.dateError = "";
      this.fetchEvents(1);
    },
  },
};
</script>

<style>
.addres {
  height: 50px;
  overflow: hidden;
}

.descr {
  height: 20px;
  overflow: hidden;
}
.organizerPanel {
  text-align: left;
  font-size: 0.875rem;
  margin-bottom: -3%;
}
.organizerName {
  margin-left: 10%;
  text-align: center;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0 10px 0;
  gap: 8px;
}
.pagination button {
  margin: 0 2px;
  padding: 6px 16px;
  border: none;
  /* background: #f0f0f0; */
  color: #333;
  font-weight: 500;
  border-radius: 4px;
}
.pagination button.active {
  background: #db2dc0;
  color: #fff;
  font-weight: bold;
}
.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.filter-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  gap: 10px;
  /* background: #f8f9fa; */

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  width: 100%;
}
.search-input {
  min-width: 180px;
  font-size: 1rem;
  color: white;
  
}

input.form-control {
    border: 1px solid #db2dc0;
}


.date-input {
  color-scheme: dark;
  min-width: 130px;
  font-size: 1rem;
  }

.date-input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  filter: brightness(0) invert(1);
  opacity: 1;
}
.date-separator {
  margin: 0 4px;
  color: #888;
  font-size: 1.1em;
}
.limit-select {
  min-width: 110px;
  font-size: 1rem;
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid #db2dc0;
  background: transparent;
  color: white;
  margin-right: 8px;
}
.limit-select option {
  color: black;
}

.sort-select {
  min-width: 140px;
  font-size: 1rem;
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: transparent;
  color: black;
  margin-right: 8px;
}
.sort-select option {
  color: black;
}
.sort-select option:checked,
.sort-select option[selected] {
  background: #db2dc0;
  color: #fff;
}

.filter-btn {
  background: #db2dc0;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.filter-btn:hover {
  background: #db2dc0;
}
.clear-btn {
  /* background: #e0e0e0; */
  color: #333;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.clear-btn:hover {
  background: #bdbdbd;
}
.date-error {
  color: #d32f2f;
  margin-left: 10px;
  font-size: 0.98em;
}
.event-count-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
  font-size: 1.05em;
  color: #333;
}
.event-count-bar strong {
  color: #db2dc0;
}

.pagination .page-item .page-link {
   
    height: auto !important;
    line-height: normal !important;
   
}


.pagination button {
  
    background: #f0f0f0 !important;
    color: #333;

}


.pagination .page-item.active > .page-link, .pagination .page-item.active > .page-link:focus, .pagination .page-item.active > .page-link:hover {
    background: #e14eca !important;
   
}

.page-item.disabled .page-link {
    color: #6c757d;
    pointer-events: none;
    cursor: auto;
    background-color: #f0f0f0;
    width: 36px;
    padding: 6px;
}

</style>
